import apiClient from '@/services/api.service';

export const commonService = {
    // async getAllBrands() {
    //     return apiClient.get('/get-all-brands');
    // },
    async getAllCategories() {
        return apiClient.get('/products/categories');
    },
    async getCategory(id) {
        return apiClient.get(`/products/categories/${id}`);
    },
    // async getSlider() {
    //     log
    //     return axios.get('https://backend.penpencilbd.com/wp-json/vthea-slider/v1/sliders');
    // },
    // async getAllSubCategoriesByCategory(categoryId) {
    //     return apiClient.get(`/products/categories/${categoryId}/subcategories`);
    // },
};